import UsaFlag from '../assets/images/flags/usa.jpg';
import CnFlag from '../assets/images/flags/cn.jpg';
import KrFlag from '../assets/images/flags/kr.png';
import JpFlag from '../assets/images/flags/jp.png';
import ThFlag from '../assets/images/flags/th.png';
import VtFlag from '../assets/images/flags/vt.png';
import IdFlag from '../assets/images/flags/id.png';

import rotatingBannerEn from '../assets/images/banners/Rotating-BannerEn.png';
import rotatingBannerCn from '../assets/images/banners/Rotating-BannerCn.png';
import rotatingBannerId from '../assets/images/banners/Rotating-BannerId.png';
import rotatingBannerJp from '../assets/images/banners/Rotating-BannerJp.png';
import rotatingBannerKo from '../assets/images/banners/Rotating-BannerKo.png';
import rotatingBannerVt from '../assets/images/banners/Rotating-BannerVt.png';
import rotatingBannerTh from '../assets/images/banners/Rotating-BannerTh.png';

export const DEFAULT_LANGUAGE = 'en';

const LANGUAGE_MAPPER = {
  en: {
    match: ['en'],
    flag: UsaFlag,
    banner: rotatingBannerEn,
  },
  cn: {
    match: ['cn', 'zh'],
    flag: CnFlag,
    banner: rotatingBannerCn,
  },
  id: {
    match: ['id'],
    flag: IdFlag,
    banner: rotatingBannerId,
  },
  jp: {
    match: ['jp', 'ja'],
    flag: JpFlag,
    banner: rotatingBannerJp,
  },
  kr: {
    match: ['kr', 'ko'],
    flag: KrFlag,
    banner: rotatingBannerKo,
  },
  th: {
    match: ['th'],
    flag: ThFlag,
    banner: rotatingBannerTh,
  },
  vt: {
    match: ['vt', 'vi'],
    flag: VtFlag,
    banner: rotatingBannerVt,
  },
}

export function getLanguageFlagMap() {
  return Object.keys(LANGUAGE_MAPPER).reduce((languageFlagMap, langCode) => {
    languageFlagMap[langCode] = LANGUAGE_MAPPER[langCode].flag;
    return languageFlagMap;
  }, {});
}

export function getLanguageCodeFromUrl(url) {
  const queryParamsMap = getQueryParametersMap(url);

  if (queryParamsMap.has('lang')) {
    const languageCode = queryParamsMap.get('lang');

    return convertLanguageCode(languageCode);
  }

  return DEFAULT_LANGUAGE;
}

/**
 * Convert ISO639-1 or locale to language code used in app
 * @param code ISO639-1 or locale
 * @returns {string} app defined code
 */
export function convertLanguageCode(code) {
  const matchingLanguage = Object.keys(LANGUAGE_MAPPER).find(langCode =>
    LANGUAGE_MAPPER[langCode].match.includes(code)
  );

  if (matchingLanguage) {
    return matchingLanguage;
  }

  return DEFAULT_LANGUAGE;
}

function getQueryParametersMap(url) {
  const queryString = url.split('?')[1];
  const queryParamsMap = new Map();

  if (queryString) {
    const queryParams = queryString.split('&');

    queryParams.forEach(param => {
      const [key, value] = param.split('=');
      queryParamsMap.set(key, value);
    });
  }

  return queryParamsMap;
}

export function getFlagByLanguageCode(code) {
  if (LANGUAGE_MAPPER[code]) {
    return LANGUAGE_MAPPER[code].flag;
  }

  return LANGUAGE_MAPPER[DEFAULT_LANGUAGE].flag; // You can set a default flag here.
}

export function getBannerByLanguageCode(code) {
  if (LANGUAGE_MAPPER[code]) {
    return LANGUAGE_MAPPER[code].banner;
  }

  return LANGUAGE_MAPPER[DEFAULT_LANGUAGE].banner; // You can set a default flag here.
}
